import { inject, Injectable } from '@angular/core';
import {
  DefaultContext,
  MutationOptions,
  OperationVariables,
  QueryOptions,
} from '@apollo/client/core';
import { Apollo } from 'apollo-angular';

import { MutationResult } from '@graphql/shared/types/mutation-result.type';
import { QueryResult } from '@graphql/shared/types/query-result.type';
import { LOADING_KEY_HEADER } from '@shared/interceptors/loading.interceptor';
import { LoadingKey } from '@shared/types/loading-key.type';

import { ServerName } from '../enums/server-name.enum';

@Injectable({ providedIn: 'root' })
export class GraphQLService {
  private readonly apollo = inject(Apollo);

  query<Result, Variables extends OperationVariables>(
    options: QueryOptions<Variables, Result> & { loadingKey?: LoadingKey },
    servername = ServerName.EmployeeGraphQL,
  ): QueryResult<Result> {
    const { loadingKey, ...queryOptions } = options;
    let context: DefaultContext = {};
    if (loadingKey) {
      context = {
        headers: { [LOADING_KEY_HEADER]: loadingKey },
      };
    }
    return this.apollo.use(servername).query<Result, Variables>({
      ...queryOptions,
      context,
    });
  }

  mutate<Result, Variables extends OperationVariables>(
    options: MutationOptions<Result, Variables> & { loadingKey?: LoadingKey },
    servername = ServerName.EmployeeGraphQL,
  ): MutationResult<Result> {
    const { loadingKey, ...queryOptions } = options;
    let context: DefaultContext = {};
    if (loadingKey) {
      context = {
        headers: { [LOADING_KEY_HEADER]: loadingKey },
      };
    }
    return this.apollo.use(servername).mutate<Result, Variables>({
      ...queryOptions,
      context,
    });
  }
}
